<template>
  <div v-if="!$vuetify.display.mdAndDown" class="placing-variants-filters">
    <placing-variants-filter-fields v-model="filters" />
  </div>

  <filters-dialog v-else v-model="filters" :default-filters="defaultPlacingVariantsFilter">
    <template #activator>
      <e-btn icon variant="tonal" class="placing-variants__with-badge">
        <e-icon name="options" />
      </e-btn>
    </template>

    <template #default="props">
      <placing-variants-filter-fields v-model="props.items" />
    </template>
  </filters-dialog>
</template>

<script setup lang="ts">
import type { PlacingVariantsFilter } from '@/parts/tariffs/types/tariffs';
import FiltersDialog from '@/core/components/common/FiltersDialog.vue';
import { EBtn, EIcon } from '@/core/components/ui';
import PlacingVariantsFilterFields from '@/parts/tariffs/components/PlacingVariantsFilterFields.vue';
import { defaultPlacingVariantsFilter } from '@/parts/tariffs/utils/tariffs';

const filters = defineModel<PlacingVariantsFilter>({ required: true });
</script>

<style scoped lang="scss">
.placing-variants-filters {
  display: contents;

  &__with-badge {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: 6px;
      right: 6px;

      min-width: 8px;
      height: 8px;

      background-color: $alert-color;
      border-radius: 50%;
    }
  }
}
</style>
